import { useMemo } from "react";

export default function Ambient() {
  const sparkles = useMemo(
    () =>
      Array.from({ length: 20 }, () => ({
        top: Math.random() * 100,
        left: Math.random() * 100,
        delay: Math.random() * 7,
        dur: 5 + Math.random() * 5,
        size: 2 + Math.random() * 3,
      })),
    []
  );

  return (
    <div className="ambient" aria-hidden="true">
      <div className="aurora-blob blob-a" />
      <div className="aurora-blob blob-b" />
      {sparkles.map((s, i) => (
        <span
          key={i}
          className="sparkle"
          style={{
            top: `${s.top}%`,
            left: `${s.left}%`,
            width: `${s.size}px`,
            height: `${s.size}px`,
            animationDelay: `${s.delay}s`,
            animationDuration: `${s.dur}s`,
          }}
        />
      ))}
      <div className="grain" />
    </div>
  );
}
